(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-promo-card-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function colSpan(el, cols) {
      var m = /span\s+(\d+)/.exec(getComputedStyle(el).gridColumnEnd);
      return m ? parseInt(m[1], 10) : cols;
    }

    function layout(grid) {
      var cards = [].slice.call(grid.children).filter(function (el) {
        return el.classList.contains('cg-card');
      });
      cards.forEach(function (c) { c.style.removeProperty('grid-column'); });
      if (grid.getAttribute('data-autofill') !== 'true' || !cards.length) return;

      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
      if (cols < 2) return;

      var rects = cards.map(function (c) { return c.getBoundingClientRect(); });
      var maxBottom = Math.max.apply(null, rects.map(function (r) { return r.bottom; }));
      var last = cards
        .map(function (c, i) { return { c: c, r: rects[i] }; })
        .filter(function (o) { return Math.abs(o.r.bottom - maxBottom) < 2; })
        .sort(function (a, b) { return a.r.left - b.r.left; });

      var used = last.reduce(function (n, o) { return n + colSpan(o.c, cols); }, 0);
      if (used > 0 && used < cols) {
        var tail = last[last.length - 1].c;
        tail.style.gridColumn = 'span ' + (colSpan(tail, cols) + cols - used);
      }
    }

    function reduceMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function videosOk(el) {
      var root = el.closest ? el.closest('.cg') : null;
      var respect = root && root.getAttribute('data-cg-rm-video') === 'true';
      return !(respect && reduceMotion());
    }

    function primeVideo(v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      if (v._cgPrimed) return;
      v._cgPrimed = true;
      v.addEventListener('pause', function () {
        if (v._cgWant && !document.hidden && !v.ended) {
          setTimeout(function () { if (v._cgWant) playVideo(v); }, 150);
        }
      });
      v.addEventListener('ended', function () {
        if (v._cgWant) { v.currentTime = 0; playVideo(v); }
      });
    }

    function retryPlay(v) {
      if (v._cgRetry) return;
      v._cgRetry = true;
      var vEvents = ['loadeddata', 'canplay'];
      var gEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
      function done() {
        v._cgRetry = false;
        vEvents.forEach(function (e) { v.removeEventListener(e, done); });
        gEvents.forEach(function (e) { window.removeEventListener(e, done, true); });
        if (v._cgWant) playVideo(v);
      }
      vEvents.forEach(function (e) { v.addEventListener(e, done); });
      gEvents.forEach(function (e) { window.addEventListener(e, done, { capture: true, passive: true }); });
    }

    function playVideo(v) {
      primeVideo(v);
      if (!v.paused && !v.ended) return;
      var p;
      try { p = v.play(); } catch (e) {}
      if (p && p.catch) p.catch(function () { retryPlay(v); });
    }

    function wantVideo(v, on) {
      primeVideo(v);
      v._cgWant = !!on;
      if (on) playVideo(v); else v.pause();
    }

    function initSlider(card) {
      if (card._cgApi) return;
      var slides = [].slice.call(card.querySelectorAll('[data-cg-slide]'));
      if (slides.length < 2) return;

      var root = card.closest('.cg');
      var autoplay = root.getAttribute('data-cg-autoplay') === 'true' && !reduceMotion();
      var pauseHover = root.getAttribute('data-cg-pause-hover') === 'true';
      var delay = (parseFloat(root.getAttribute('data-cg-delay')) || 5) * 1000;
      var dots = [].slice.call(card.querySelectorAll('[data-cg-dot]'));
      var cur = 0, timer = null, inView = false, hovered = false, focused = false, held = false;

      slides.forEach(function (s) {
        s.querySelectorAll('video').forEach(function (v) {
          primeVideo(v);
          v.removeAttribute('autoplay');
        });
      });

      function setVideos(slide, play) {
        slide.querySelectorAll('video').forEach(function (v) {
          wantVideo(v, play && inView && videosOk(card));
        });
      }

      function stop() { clearTimeout(timer); timer = null; }
      function schedule() {
        stop();
        if (autoplay && inView && !hovered && !focused && !held) timer = setTimeout(next, delay);
      }

      function goTo(n, dir) {
        n = (n + slides.length) % slides.length;
        if (n === cur) { schedule(); return; }
        if (dir === undefined) dir = n > cur ? 1 : -1;
        var from = slides[cur], to = slides[n];

        to.style.transition = 'none';
        to.classList.toggle('is-prev', dir < 0);
        void to.offsetWidth;
        to.style.transition = '';

        from.classList.remove('is-active');
        from.classList.toggle('is-prev', dir > 0);
        to.classList.remove('is-prev');
        to.classList.add('is-active');

        slides.forEach(function (s, i) {
          var active = i === n;
          s.toggleAttribute('inert', !active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === n);
          if (i === n) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });

        setVideos(from, false);
        setVideos(to, true);
        cur = n;
        schedule();
      }

      function next() { goTo(cur + 1, 1); }
      function prev() { goTo(cur - 1, -1); }

      var prevBtn = card.querySelector('[data-cg-prev]');
      var nextBtn = card.querySelector('[data-cg-next]');
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      if (pauseHover) {
        card.addEventListener('mouseenter', function () { hovered = true; stop(); });
        card.addEventListener('mouseleave', function () { hovered = false; schedule(); });
      }
      card.addEventListener('focusin', function () { focused = true; stop(); });
      card.addEventListener('focusout', function (e) {
        if (!card.contains(e.relatedTarget)) { focused = false; schedule(); }
      });

      var startX = null, startY = null;
      card.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      card.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) next(); else prev(); }
      }, { passive: true });

      function onView(visible) {
        inView = visible;
        if (visible) {
          card.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
          setVideos(slides[cur], true);
          schedule();
        } else {
          stop();
          slides.forEach(function (s) { setVideos(s, false); });
        }
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onView(entries[0].isIntersecting);
        }, { threshold: 0.15 }).observe(card);
      } else {
        onView(true);
      }

      card._cgApi = {
        show: function (el) { var i = slides.indexOf(el); goTo(i < 0 ? 0 : i); },
        hold: function (on) { held = on; if (on) stop(); else schedule(); }
      };
    }

    function bindVideos(root) {
      var videos = (root || document).querySelectorAll('.cg-card:not(.cg-card--slider) .cg-video');
      videos.forEach(function (video) {
        primeVideo(video);
        if (video._cgBound) return;
        video._cgBound = true;
        if (!videosOk(video)) { video.removeAttribute('autoplay'); video.pause(); return; }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) { wantVideo(entry.target, entry.isIntersecting); });
          }, { threshold: 0.01 }).observe(video);
        } else {
          wantVideo(video, true);
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('[data-cg-grid]').forEach(function (grid) {
        if (grid._cgInit) return;
        grid._cgInit = true;
        var width = 0;
        if ('ResizeObserver' in window) {
          new ResizeObserver(function () {
            if (grid.clientWidth !== width) { width = grid.clientWidth; layout(grid); }
          }).observe(grid);
        } else {
          window.addEventListener('resize', function () { layout(grid); });
        }
        layout(grid);
      });
      bindVideos(root);
      (root || document).querySelectorAll('[data-cg-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      document.querySelectorAll('.cg-video').forEach(function (v) { if (v._cgWant) playVideo(v); });
    });

    function editorCard(e) {
      var card = e.target.closest && e.target.closest('.cg-card');
      return card && card._cgApi ? card : null;
    }
    document.addEventListener('shopify:block:select', function (e) {
      var card = editorCard(e);
      if (!card) return;
      card._cgApi.hold(true);
      card._cgApi.show(e.target.closest('[data-cg-slide]'));
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var card = editorCard(e);
      if (card) card._cgApi.hold(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["family-image-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('.mw-family-image-callery__link');
  const modal = document.querySelector('.mw-modal');
  const modalContent = modal.querySelector('.mw-modal-content');
  const closeModal = document.querySelector('.mw-modal-close');
  const tabButtons = document.querySelectorAll('.mw-gallery-tab');
  const verticalTabButtons = document.querySelectorAll('.mw-gallery-tab-vertical');
  const galleryItems = document.querySelectorAll('.mw-family-image-callery__item');
  let currentIndex = 0;
  let currentSlide = 0;
  let slideshowImages = [];
  let isMobile = window.innerWidth <= 768;
  
  // Check if mobile on resize
  window.addEventListener('resize', () => {
    isMobile = window.innerWidth <= 768;
  });
  
  // Tab filtering functionality (only for tabbed layout)
  function filterGallery(selectedTab) {
    galleryItems.forEach(item => {
      const itemTab = item.dataset.tab;
      if (selectedTab === 'all' || itemTab === selectedTab) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }
  
  // Scroll to section functionality (for vertical sections)
  function scrollToSection(selectedSection) {
    if (selectedSection === 'all') {
      // Scroll to top of gallery
      const galleryContainer = document.querySelector('#section-{{ section.id }}');
      if (galleryContainer) {
        galleryContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Scroll to specific section
      const targetSection = document.getElementById(`section-${selectedSection}`);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
  
  // --- CATEGORY HEADER/DESCRIPTION LOGIC FOR TABBED MODE ---
  const categoryDataScript = document.getElementById('mw-category-data');
  let categoryData = {};
  if (categoryDataScript) {
    try {
      categoryData = JSON.parse(categoryDataScript.textContent);
    } catch (e) { categoryData = {}; }
  }
  const tabbedHeader = document.querySelector('.mw-gallery-section-header-tabbed');
  const tabbedHeading = document.getElementById('mw-tabbed-category-heading');
  const tabbedDescription = document.getElementById('mw-tabbed-category-description');
  function updateTabbedHeader(tab) {
    if (!tabbedHeader) return;
    const catKey = Object.keys(categoryData).find(k => k.replace(/\s+/g, '-').toLowerCase() === tab) || 'all';
    const cat = categoryData[catKey] || categoryData['all'];
    tabbedHeading.textContent = cat.name || 'All';
    tabbedDescription.innerHTML = cat.description || '';
  }
  // Set initial header
  updateTabbedHeader('all');
  
  // Original tab button click handlers (for filtering)
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons
      tabButtons.forEach(btn => btn.classList.remove('active'));
      // Add active class to clicked button
      button.classList.add('active');
      // Filter gallery
      filterGallery(button.dataset.tab);
      // Update header/description
      updateTabbedHeader(button.dataset.tab);
    });
  });
  
  // Vertical section tab button click handlers (for scrolling)
  verticalTabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove active class from all vertical buttons
      verticalTabButtons.forEach(btn => btn.classList.remove('active'));
      // Add active class to clicked button
      button.classList.add('active');
      // Scroll to section
      scrollToSection(button.dataset.section);
      
      // Reset active state after 1 second for vertical layout mode
      setTimeout(() => {
        verticalTabButtons.forEach(btn => btn.classList.remove('active'));
      }, 1000);
    });
  });
  
  function showModal(index) {
    const subImages = images[index].dataset.subImages.split(',').filter(url => url.trim() !== '');
    slideshowImages = subImages;
    currentSlide = 0;
    
    if (isMobile) {
      // Mobile: Show grid layout
      modalContent.className = 'mw-modal-content mobile-grid';
      modalContent.innerHTML = '';
      subImages.forEach(src => {
        const img = document.createElement('img');
        img.src = src.trim();
        img.alt = "Secondary Image";
        modalContent.appendChild(img);
      });
    } else {
      // Desktop: Show slideshow
      modalContent.className = 'mw-modal-content';
      modalContent.innerHTML = `
        <div class="mw-slideshow-container">
          <div class="mw-slideshow-wrapper">
            <button class="mw-slideshow-nav mw-slideshow-prev">&lt;</button>
            <button class="mw-slideshow-nav mw-slideshow-next">&gt;</button>
          </div>
          <div class="mw-slideshow-thumbnails"></div>
        </div>
      `;
      
      const slideshowWrapper = modalContent.querySelector('.mw-slideshow-wrapper');
      const thumbnailsContainer = modalContent.querySelector('.mw-slideshow-thumbnails');
      
      // Create slideshow images with pre-loading
      subImages.forEach((src, i) => {
        const img = document.createElement('img');
        img.alt = "Secondary Image";
        
        // Load all images immediately for smooth transitions
        img.src = src.trim();
        if (i === 0) {
          img.classList.add('active');
        }
        
        slideshowWrapper.appendChild(img);
        
        // Create thumbnail
        const thumbnail = document.createElement('div');
        thumbnail.className = 'mw-slideshow-thumbnail';
        if (i === 0) thumbnail.classList.add('active');
        thumbnail.addEventListener('click', () => goToSlide(i));
        
        const thumbnailImg = document.createElement('img');
        thumbnailImg.src = src.trim();
        thumbnailImg.alt = "Thumbnail";
        thumbnail.appendChild(thumbnailImg);
        
        // Add number overlay
        const numberOverlay = document.createElement('div');
        numberOverlay.className = 'mw-slideshow-thumbnail-number';
        numberOverlay.textContent = i + 1;
        thumbnail.appendChild(numberOverlay);
        
        thumbnailsContainer.appendChild(thumbnail);
      });
      
      // Pre-load all images in background for smooth transitions
      subImages.forEach((src, i) => {
        if (i > 0) { // Skip first image as it's already loaded
          const preloadImg = new Image();
          preloadImg.src = src.trim();
        }
      });
      
      // Add navigation event listeners
      const prevBtn = modalContent.querySelector('.mw-slideshow-prev');
      const nextBtn = modalContent.querySelector('.mw-slideshow-next');
      
      prevBtn.addEventListener('click', () => {
        currentSlide = (currentSlide - 1 + slideshowImages.length) % slideshowImages.length;
        updateSlideshow();
      });
      
      nextBtn.addEventListener('click', () => {
        currentSlide = (currentSlide + 1) % slideshowImages.length;
        updateSlideshow();
      });
      
      // Keyboard navigation
      document.addEventListener('keydown', handleKeydown);
    }
    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  function updateSlideshow() {
    const images = modalContent.querySelectorAll('.mw-slideshow-wrapper img');
    const thumbnails = modalContent.querySelectorAll('.mw-slideshow-thumbnail');
    
    images.forEach((img, i) => {
      img.classList.toggle('active', i === currentSlide);
    });
    
    thumbnails.forEach((thumbnail, i) => {
      thumbnail.classList.toggle('active', i === currentSlide);
    });
  }
  
  function goToSlide(index) {
    currentSlide = index;
    updateSlideshow();
  }
  
  function handleKeydown(e) {
    if (!modal.classList.contains('show')) return;
    
    if (e.key === 'ArrowLeft') {
      currentSlide = (currentSlide - 1 + slideshowImages.length) % slideshowImages.length;
      updateSlideshow();
    } else if (e.key === 'ArrowRight') {
      currentSlide = (currentSlide + 1) % slideshowImages.length;
      updateSlideshow();
    } else if (e.key === 'Escape') {
      hideModal();
    }
  }
  
  function hideModal() {
    modal.classList.remove('show');
    document.removeEventListener('keydown', handleKeydown);
  }
  
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault();
      showModal(index);
    });
  });
  
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      hideModal();
    }
  });
  
  closeModal.addEventListener('click', hideModal);

  // Debug: Log gallery items and their dates in order of appearance
  function logGalleryOrder() {
    const items = document.querySelectorAll('.mw-family-image-callery__item');
    const order = [];
    items.forEach((item, idx) => {
      const title = item.querySelector('.mw-family-image-callery__title')?.textContent?.trim() || '';
      // Try to get the date from a data attribute (add this in Liquid below)
      const date = item.getAttribute('data-gallery-item-date') || '';
      order.push({ index: idx, title, date });
    });
    console.log('Gallery item order (left to right):', order);
  }
  // Hide the gallery grid until sorting is complete, show skeletons in grid
  function showSkeletons() {
    const galleries = document.querySelectorAll('.mw-family-image-callery');
    galleries.forEach(gallery => {
      gallery.classList.add('mw-gallery-hidden');
    });
  }
  function hideSkeletons() {
    const galleries = document.querySelectorAll('.mw-family-image-callery');
    galleries.forEach(gallery => {
      gallery.classList.remove('mw-gallery-hidden');
    });
  }
  showSkeletons();
  // JavaScript sort: ensure gallery items are ordered by date (newest first)
  function sortGalleryItemsByDate() {
    const galleries = document.querySelectorAll('.mw-family-image-callery');
    galleries.forEach(gallery => {
      const items = Array.from(gallery.querySelectorAll('.mw-family-image-callery__item'));
      // Only sort real items, not skeletons
      const realItems = items.filter(item => !item.classList.contains('mw-gallery-skeleton-item'));
      realItems.sort((a, b) => {
        const dateA = a.getAttribute('data-gallery-item-date') || '';
        const dateB = b.getAttribute('data-gallery-item-date') || '';
        // Newest first
        return dateB.localeCompare(dateA);
      });
      // Place skeletons first, then real items
      const skeletons = items.filter(item => item.classList.contains('mw-gallery-skeleton-item'));
      skeletons.forEach(item => gallery.appendChild(item));
      realItems.forEach(item => gallery.appendChild(item));
    });
  }
  setTimeout(() => {
    sortGalleryItemsByDate();
    hideSkeletons();
    logGalleryOrder();
  }, 300); // Simulate loading delay for skeleton effect
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('.mw-image-gallery__link');
    const modal = document.querySelector('.mw-modal');
    const modalContent = modal.querySelector('.mw-modal-content');
    const closeModal = document.querySelector('.mw-modal-close');
    const tabButtons = document.querySelectorAll('.mw-gallery-tab');
    const verticalTabButtons = document.querySelectorAll('.mw-gallery-tab-vertical');
    const galleryItems = document.querySelectorAll('.mw-image-gallery__item');
    let currentIndex = 0;
    let currentSlide = 0;
    let slideshowImages = [];
    let slideshowTypes = [];
    let slideshowVideos = [];
    let isMobile = window.innerWidth <= 768;
    
    // Check if mobile on resize
    window.addEventListener('resize', () => {
      isMobile = window.innerWidth <= 768;
    });
    
    // Tab filtering functionality (only for tabbed layout)
    function filterGallery(selectedTab) {
      galleryItems.forEach(item => {
        const itemTab = item.dataset.tab;
        if (selectedTab === 'all' || itemTab === selectedTab) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }
    
    // Scroll to section functionality (for vertical sections)
    function scrollToSection(selectedSection) {
      if (selectedSection === 'all') {
        // Scroll to top of gallery
        const galleryContainer = document.querySelector('#section-{{ section.id }}');
        if (galleryContainer) {
          galleryContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        // Scroll to specific section
        const targetSection = document.getElementById(`section-${selectedSection}`);
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
    
    // --- CATEGORY HEADER/DESCRIPTION LOGIC FOR TABBED MODE ---
    const categoryDataScript = document.getElementById('mw-category-data');
    let categoryData = {};
    if (categoryDataScript) {
      try {
        categoryData = JSON.parse(categoryDataScript.textContent);
      } catch (e) { categoryData = {}; }
    }
    const tabbedHeader = document.querySelector('.mw-gallery-section-header-tabbed');
    const tabbedHeading = document.getElementById('mw-tabbed-category-heading');
    const tabbedDescription = document.getElementById('mw-tabbed-category-description');
    function updateTabbedHeader(tab) {
      if (!tabbedHeader) return;
      const catKey = Object.keys(categoryData).find(k => k.replace(/\s+/g, '-').toLowerCase() === tab) || 'all';
      const cat = categoryData[catKey] || categoryData['all'];
      tabbedHeading.textContent = cat.name || 'All';
      tabbedDescription.innerHTML = cat.description || '';
    }
    // Set initial header
    updateTabbedHeader('all');
    
    // Original tab button click handlers (for filtering)
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('active'));
        // Add active class to clicked button
        button.classList.add('active');
        // Filter gallery
        filterGallery(button.dataset.tab);
        // Update header/description
        updateTabbedHeader(button.dataset.tab);
      });
    });
    
    // Vertical section tab button click handlers (for scrolling)
    verticalTabButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all vertical buttons
        verticalTabButtons.forEach(btn => btn.classList.remove('active'));
        // Add active class to clicked button
        button.classList.add('active');
        // Scroll to section
        scrollToSection(button.dataset.section);
        
        // Reset active state after 1 second for vertical layout mode
        setTimeout(() => {
          verticalTabButtons.forEach(btn => btn.classList.remove('active'));
        }, 1000);
      });
    });
    
    function showModal(index) {
      const linkEl = images[index];
      const rawImages = (linkEl.dataset.subImages || '').split(',');
      const rawTypes = (linkEl.dataset.subTypes || '').split(',');
      const rawVideos = (linkEl.dataset.subVideos || '').split(',');
  
      const subImages = [];
      const subTypes = [];
      const subVideos = [];
  
      rawImages.forEach((url, i) => {
        const trimmed = url.trim();
        if (!trimmed) return;
        subImages.push(trimmed);
        subTypes.push((rawTypes[i] || 'image').trim() || 'image');
        subVideos.push((rawVideos[i] || '').trim());
      });
  
      slideshowImages = subImages;
      slideshowTypes = subTypes;
      slideshowVideos = subVideos;
      currentSlide = 0;
  
      const hasVideo = subTypes.some(t => (t || 'image') === 'video');
      
      if (isMobile) {
        // Mobile: Show grid layout, including videos
        modalContent.className = 'mw-modal-content mobile-grid';
        modalContent.innerHTML = '';
        subImages.forEach((src, i) => {
          const type = subTypes[i] || 'image';
          const videoSrc = subVideos[i] || '';
  
          if (type === 'video' && videoSrc) {
            const wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
  
            const video = document.createElement('video');
            video.controls = true;
            video.preload = 'metadata';
            video.playsInline = true;
            video.style.width = '100%';
            video.style.height = 'auto';
            // Use the image URL as poster
            video.poster = src;
  
            const source = document.createElement('source');
            source.src = videoSrc;
            // Let the browser/server determine the correct MIME type
            video.appendChild(source);
  
            wrapper.appendChild(video);
            modalContent.appendChild(wrapper);
          } else {
            const img = document.createElement('img');
            img.src = src;
            img.alt = "Secondary Image";
            modalContent.appendChild(img);
          }
        });
      } else {
        // Desktop: Show slideshow
        modalContent.className = 'mw-modal-content';
        modalContent.innerHTML = `
          <div class="mw-slideshow-container">
            <div class="mw-slideshow-wrapper">
              <button class="mw-slideshow-nav mw-slideshow-prev">&lt;</button>
              <button class="mw-slideshow-nav mw-slideshow-next">&gt;</button>
            </div>
            <div class="mw-slideshow-thumbnails"></div>
          </div>
        `;
        
        const slideshowWrapper = modalContent.querySelector('.mw-slideshow-wrapper');
        const thumbnailsContainer = modalContent.querySelector('.mw-slideshow-thumbnails');
        
        // Create slideshow media (images and videos) with pre-loading
        subImages.forEach((src, i) => {
          const type = subTypes[i] || 'image';
          const videoSrc = subVideos[i] || '';
          let mediaEl;
  
          if (type === 'video' && videoSrc) {
            mediaEl = document.createElement('video');
            mediaEl.controls = true;
            mediaEl.preload = 'metadata';
            mediaEl.playsInline = true;
            // Use the image URL as poster so we always see a thumbnail
            mediaEl.poster = src;
  
            const source = document.createElement('source');
            source.src = videoSrc;
            // Let the browser/server determine the correct MIME type
            mediaEl.appendChild(source);
          } else {
            mediaEl = document.createElement('img');
            mediaEl.alt = "Secondary Image";
            mediaEl.src = src;
          }
  
          mediaEl.classList.add('mw-slideshow-media');
          if (i === 0) {
            mediaEl.classList.add('active');
          }
  
          slideshowWrapper.appendChild(mediaEl);
          
          // Create thumbnail
          const thumbnail = document.createElement('div');
          thumbnail.className = 'mw-slideshow-thumbnail';
          if (i === 0) thumbnail.classList.add('active');
          thumbnail.addEventListener('click', () => goToSlide(i));
          
          const thumbnailImg = document.createElement('img');
          thumbnailImg.src = src;
          thumbnailImg.alt = "Thumbnail";
          thumbnail.appendChild(thumbnailImg);
          
          // Add number overlay
          const numberOverlay = document.createElement('div');
          numberOverlay.className = 'mw-slideshow-thumbnail-number';
          numberOverlay.textContent = i + 1;
          thumbnail.appendChild(numberOverlay);
          
          thumbnailsContainer.appendChild(thumbnail);
        });
        
        // Add central play button overlay only if there is at least one video slide
        if (hasVideo) {
          const playButton = document.createElement('button');
          playButton.type = 'button';
          playButton.className = 'mw-slideshow-play-button';
          slideshowWrapper.appendChild(playButton);
  
          playButton.addEventListener('click', () => {
            const activeMedia = slideshowWrapper.querySelector('.mw-slideshow-media.active');
            if (activeMedia && activeMedia.tagName.toLowerCase() === 'video') {
              if (activeMedia.paused) {
                activeMedia.play();
                playButton.classList.add('hidden');
              } else {
                activeMedia.pause();
                playButton.classList.remove('hidden');
              }
            }
          });
  
          // Ensure initial visibility is correct based on the first slide
          updateSlideshow();
        }
  
        // Pre-load all images in background for smooth transitions
        subImages.forEach((src, i) => {
          if (i > 0) { // Skip first image as it's already loaded
            const preloadImg = new Image();
            preloadImg.src = src.trim();
          }
        });
        
        // Add navigation event listeners
        const prevBtn = modalContent.querySelector('.mw-slideshow-prev');
        const nextBtn = modalContent.querySelector('.mw-slideshow-next');
        
        prevBtn.addEventListener('click', () => {
          currentSlide = (currentSlide - 1 + slideshowImages.length) % slideshowImages.length;
          updateSlideshow();
        });
        
        nextBtn.addEventListener('click', () => {
          currentSlide = (currentSlide + 1) % slideshowImages.length;
          updateSlideshow();
        });
        
        // Keyboard navigation
        document.addEventListener('keydown', handleKeydown);
      }
      
      modal.classList.add('show');
      currentIndex = index;
    }
    
    function updateSlideshow() {
      const mediaElements = modalContent.querySelectorAll('.mw-slideshow-wrapper .mw-slideshow-media');
      const thumbnails = modalContent.querySelectorAll('.mw-slideshow-thumbnail');
      const slideshowWrapper = modalContent.querySelector('.mw-slideshow-wrapper');
      const playButton = slideshowWrapper ? slideshowWrapper.querySelector('.mw-slideshow-play-button') : null;
      
      mediaElements.forEach((el, i) => {
        const isActive = i === currentSlide;
        el.classList.toggle('active', isActive);
        if (!isActive && el.tagName.toLowerCase() === 'video') {
          el.pause();
        }
      });
      
      thumbnails.forEach((thumbnail, i) => {
        thumbnail.classList.toggle('active', i === currentSlide);
      });
  
      if (playButton) {
        const activeMedia = mediaElements[currentSlide];
        if (activeMedia && activeMedia.tagName.toLowerCase() === 'video') {
          playButton.classList.remove('hidden');
        } else {
          playButton.classList.add('hidden');
        }
      }
    }
    
    function goToSlide(index) {
      currentSlide = index;
      updateSlideshow();
    }
    
    function handleKeydown(e) {
      if (!modal.classList.contains('show')) return;
      
      if (e.key === 'ArrowLeft') {
        currentSlide = (currentSlide - 1 + slideshowImages.length) % slideshowImages.length;
        updateSlideshow();
      } else if (e.key === 'ArrowRight') {
        currentSlide = (currentSlide + 1) % slideshowImages.length;
        updateSlideshow();
      } else if (e.key === 'Escape') {
        hideModal();
      }
    }
    
    function hideModal() {
      modal.classList.remove('show');
      document.removeEventListener('keydown', handleKeydown);
      const videos = modalContent.querySelectorAll('video');
      videos.forEach(video => video.pause());
    }
    
    images.forEach((image, index) => {
      image.addEventListener('click', (e) => {
        e.preventDefault();
        showModal(index);
      });
    });
    
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        hideModal();
      }
    });
    
    closeModal.addEventListener('click', hideModal);
  
    // Debug: Log gallery items and their dates in order of appearance
    function logGalleryOrder() {
      const items = document.querySelectorAll('.mw-image-gallery__item');
      const order = [];
      items.forEach((item, idx) => {
        const title = item.querySelector('.mw-image-gallery__title')?.textContent?.trim() || '';
        // Try to get the date from a data attribute (add this in Liquid below)
        const date = item.getAttribute('data-gallery-item-date') || '';
        order.push({ index: idx, title, date });
      });
      console.log('Gallery item order (left to right):', order);
    }
    // Hide the gallery grid until sorting is complete, show skeletons in grid
    function showSkeletons() {
      const galleries = document.querySelectorAll('.mw-image-gallery');
      galleries.forEach(gallery => {
        gallery.classList.add('mw-gallery-hidden');
      });
    }
    function hideSkeletons() {
      const galleries = document.querySelectorAll('.mw-image-gallery');
      galleries.forEach(gallery => {
        gallery.classList.remove('mw-gallery-hidden');
      });
    }
    showSkeletons();
    // JavaScript sort: ensure gallery items are ordered by date (newest first)
    function sortGalleryItemsByDate() {
      const galleries = document.querySelectorAll('.mw-image-gallery');
      galleries.forEach(gallery => {
        const items = Array.from(gallery.querySelectorAll('.mw-image-gallery__item'));
        // Only sort real items, not skeletons
        const realItems = items.filter(item => !item.classList.contains('mw-gallery-skeleton-item'));
        realItems.sort((a, b) => {
          const dateA = a.getAttribute('data-gallery-item-date') || '';
          const dateB = b.getAttribute('data-gallery-item-date') || '';
          // Newest first
          return dateB.localeCompare(dateA);
        });
        // Place skeletons first, then real items
        const skeletons = items.filter(item => item.classList.contains('mw-gallery-skeleton-item'));
        skeletons.forEach(item => gallery.appendChild(item));
        realItems.forEach(item => gallery.appendChild(item));
      });
    }
    setTimeout(() => {
      sortGalleryItemsByDate();
      hideSkeletons();
      logGalleryOrder();
    }, 300); // Simulate loading delay for skeleton effect
  });
  
  } catch(e) { console.error(e); }
})();
})();
